<template lang="pug">
  div(class="form-document-share")
    div(
      v-if="!xsDevice"
      class="form-document-share__header"
    )
      h2(class="title-32px bold mb-8") {{ $t('Share this document') }}
      v-form
        div(class="form-document-share__add")
          div(class="form-document-share__add-content")
            v-tooltip(
              v-model="showWrongEdrpouTooltip"
              bottom
              nudge-top="35"
              min-width="350"
              nudge-left="40"
              content-class="form-document-share__tooltip-content"
            )
              template(v-slot:activator="data")
                ValidationObserver(
                  ref="email"
                  slim
                  class="w-100"
                )
                  ValidationProvider(
                    :rules="emailInputRules"
                    vid="email"
                    v-slot="{ errors }"
                    name="Email"
                    mode="lazy"
                  )
                    v-text-field(
                      v-model.trim="email"
                      filled
                      :error-messages="errors"
                      :loading="inputLoading"
                      :label="$t('Enter user email or EDRPOU')"
                      class="form-document-share__add-input"
                      data-test="document-share-email-input"
                      :hide-details="xsDevice"
                      :hint="$t('Add user email or EDRPOU and click +')"
                      @keyup.native.enter="addUser"
                    )
                      template(v-slot:append)
                        v-btn(
                          v-if="email && !errors.length && !inputLoading"
                          icon
                          data-test="document-share-add-user-btn"
                          @click="addUser"
                          class="form-document-share__plus-btn"
                        )
                          e-svg-icon circle-primary-plus
              div(class="form-document-share__tooltip pa-2")
                v-btn(
                  icon
                  data-test="document-share-tooltip-close-btn"
                  class="form-document-share__tooltip-close"
                  @click="showWrongEdrpouTooltip = false"
                )
                  e-svg-icon cross-close
                div(class="form-document-share__tooltip-title") {{ $t('Send document to E-mail') }}
                div(class="form-document-share__tooltip-text") {{ wrongEdrpouTooltipMessage }}
          div(class="form-document-share__add-action")
            v-select(
              v-model="action"
              :items="formattedParticipantActions"
              filled
              data-test="document-share-action-select"
              :menuProps="{ bottom: true, offsetY: true }"
            )
    div(class="form-document-share__content")
      div(
        class="text-16px dark pb-2"
        :class="{ 'pb-4': !xsDevice }"
      ) {{ $t('Users with access') }}
      div(
        v-if="!participantsLoading"
        class="form-document-share__participants"
      )
        div(class="form-document-share__add")
          div(class="form-document-share__add-content")
            div
              div(class="form-document-share__icon form-document-share__icon--gray")
                v-img(
                  :src="require('~/assets/images/person.png')"
                  max-width="16"
                )
            div
              div(class="text-14px dark") {{ xsDevice ? $t('You (Owner)') : $t('You') }}
              div(class="text-14px light") {{ $User.email }}
          div(
            v-if="!xsDevice"
            class="form-document-share__add-action"
          )
            v-select(
              v-model="requiredOwnerSignature"
              :items="ownerActions"
              filled
              hide-details
              :disabled="isDocumentSent"
              dense
              data-test="document-share-owner-action-select"
              :menuProps="{ bottom: true, offsetY: true }"
            )
        div(
          class="form-document-share__add"
          v-for="user in participants"
          :key="user.id"
        )
          div(class="form-document-share__add-content")
            div
              div(class="form-document-share__icon form-document-share__icon--gray")
                v-img(
                  :src="require('~/assets/images/person.png')"
                  max-width="16"
                )
            div
              div(class="text-14px dark") {{ getParticipantName(user) }}
              div(
                v-if="user.edrpou"
                class="text-14px light"
              ) {{ $t('Edrpou') }} {{ user.edrpou }}
            div(
              v-if="xsDevice"
              class="d-flex justify-end w-100"
            )
              v-btn(
                icon
                disabled
                class="form-document-share__action-icon--disabled"
              )
                e-svg-icon(size="sm") arrow-down
              v-btn(
                v-if="canDeleteParticipant(user)"
                icon
                data-test="document-share-delete-user-btn"
                @click="deleteParticipant(user)"
                :loading="participantsDeleteLoading[user.id]"
              )
                e-svg-icon trash
          div(
            v-if="!xsDevice"
            class="form-document-share__add-action"
          )
            v-btn(
              v-if="canDeleteParticipant(user)"
              class="form-document-share__delete"
              icon
              data-test="document-share-delete-user-desktop-btn"
              @click="deleteParticipant(user)"
              :loading="participantsDeleteLoading[user.id]"
            )
              e-svg-icon trash
            v-select(
              :items="participantActions"
              :value="actionByRoleMap[user.role]"
              filled
              hide-details
              dense
              disabled
              data-test="document-share-participant-action-select"
              :menuProps="{ bottom: true, offsetY: true }"
            )
        div(
          class="form-document-share__add"
          v-for="user in newUsers"
          :key="user.id"
        )
          div(class="form-document-share__add-content")
            div
              div(class="form-document-share__icon form-document-share__icon--gray")
                v-img(
                  :src="require('~/assets/images/person.png')"
                  max-width="16"
                )
            div
              div(class="text-14px") {{ user.name || user.email }}
              div(
                v-if="user.edrpou"
                class="text-14px light"
              ) {{ $t('Edrpou') }} {{ user.edrpou }}
            div(
              v-if="xsDevice"
              class="d-flex justify-end w-100"
            )
              v-btn(
                icon
                disabled
                class="form-document-share__action-icon--disabled"
              )
                e-svg-icon(size="sm") arrow-down
              v-btn(
                icon
                data-test="document-share-delete-regular-user-btn"
                @click="deleteUser(user.id)"
              )
                e-svg-icon trash
          div(
            v-if="!xsDevice"
            class="form-document-share__add-action"
          )
            v-btn(
              class="form-document-share__delete"
              icon
              data-test="document-share-delete-regular-user-desktop-btn"
              @click="deleteUser(user.id)"
            )
              e-svg-icon trash
            v-select(
              v-model="user.action"
              :items="formattedParticipantActions"
              filled
              hide-details
              dense
              data-test="document-share-new-user-action-select"
              :menuProps="{ bottom: true, offsetY: true }"
            )
      div(
        v-else
        class="d-flex align-center justify-center"
      )
        e-progress-circular(
          size="lg"
          width="4"
          color="#161b25"
        )
      div(
        class="text-14px dark pb-2"
        :class="{ 'pb-4': !xsDevice }"
      ) {{ $t('Public access') }}
      div(class="form-document-share__add")
        div(class="form-document-share__add-content")
          div
            div(
              class="form-document-share__icon"
              :class="{ 'form-document-share__icon--green': isPublicAccess }"
            )
              e-svg-icon(:name="isPublicAccess ? 'globe' : 'lock'")
          div(class="w-100")
            div(
              v-if="xsDevice"
              class="text-14px dark"
            ) {{ isPrivateAccess ? $t('Private access') : $t('Everyone, who has link') }}
            v-select(
              v-if="!xsDevice"
              v-model="documentPrivacy"
              :items="documentAccesses"
              :menuProps="{ bottom: true, offsetY: true }"
              :loading="deleteLinkLoading"
              dense
              height="20"
              hide-details
              class="form-document-share__select"
              data-test="document-share-privacy-select"
              :class="{ 'form-document-share__select--private': isPrivateAccess }"
            )
            div(class="text-14px light form-document-share__email--margin") {{ isPrivateAccess ? $t('Only users with access to open this document') : $t('Anybody with document link') }}
            div(
              v-if="xsDevice"
              class="text-14px light dark"
            ) {{ publicAction === 'view' ? $t('Can view') : $t('Can sign') }}
          div(
            v-if="xsDevice"
            class="d-flex justify-end"
          )
            v-menu(
              content-class="form-document-share__add-mobile-menu"
              :close-on-content-click="false"
              top
            )
              template(v-slot:activator="{ on, attrs }")
                v-btn(
                  icon
                  v-on="on"
                  data-test="document-share-mobile-menu-btn"
                )
                  e-svg-icon(size="sm") arrow-down
              div(class="form-document-share__add-mobile")
                div(class="text-14px light mb-2") {{ $t('Who can open document') }}
                div(class="form-document-share__add-mobile-form")
                  v-btn(
                    class="form-document-share__add-mobile-btn form-document-share__add-mobile-btn--top"
                    height="48"
                    data-test="document-share-privacy-public-btn"
                    @click="documentPrivacy = 'public'"
                  )
                    e-svg-icon(
                      v-if="documentPrivacy === 'public'"
                      class="form-document-share__add-mobile-btn-icon"
                    ) check-primary
                    | {{ $t('Everyone, who has link') }}
                  v-btn(
                    class="form-document-share__add-mobile-btn form-document-share__add-mobile-btn--bottom"
                    height="48"
                    data-test="document-share-privacy-private-btn"
                    @click="documentPrivacy = 'private'"
                  )
                    e-svg-icon(
                      v-if="documentPrivacy === 'private'"
                      class="form-document-share__add-mobile-btn-icon"
                    ) check-primary
                    | {{ $t('Private access') }}
                div(
                  v-if="isPublicAccess"
                  class="text-14px light mb-2 mt-6"
                ) {{ $t('User can') }}
                div(
                  v-if="isPublicAccess"
                  class="form-document-share__add-mobile-form"
                )
                  v-btn(
                    class="form-document-share__add-mobile-btn form-document-share__add-mobile-btn--top"
                    data-test="document-share-action-view-btn"
                    @click="publicAction = 'view'"
                  )
                    e-svg-icon(
                      v-if="publicAction === 'view'"
                      class="form-document-share__add-mobile-btn-icon"
                    ) check-primary
                    | {{ $t('To view') }}
                  v-btn(
                    class="form-document-share__add-mobile-btn form-document-share__add-mobile-btn--bottom"
                    data-test="document-share-action-sign-btn"
                    @click="publicAction = 'sign'"
                  )
                    e-svg-icon(
                      v-if="publicAction === 'sign'"
                      class="form-document-share__add-mobile-btn-icon"
                    ) check-primary
                    | {{ $t('To sign') }}
        div(
          v-if="isPublicAccess && !xsDevice"
          class="form-document-share__add-action"
        )
          v-select(
            v-model="publicAction"
            :items="formattedParticipantActions"
            filled
            hide-details
            dense
            data-test="document-share-public-action-select"
            :menuProps="{ bottom: true, offsetY: true }"
          )
    div(
      class="form-document-share__actions"
      :class="{ public: isPublicAccess }"
    )
      block-document-share-link-socials(
        v-if="isPublicAccess"
        :copy-loading="copyLoading"
        @copy="handleCopyLink(document, true, publicAction)"
        @shareMessenger="handleShareMessenger(document, $event, publicAction)"
        @sms="handleNotifySms(false)"
      )
      v-btn(
        v-if="hasAddedUsers"
        id="send"
        :loading="loading"
        :disabled="disableSubmit"
        class="main-button"
        data-test="document-share-send-btn"
        @click="submit"
      ) {{ hasAddedUsers ? $t('Send') : $t('Ready') }}
</template>

<script>
import { mapGetters } from 'vuex'
import EProgressCircular from '~/components/elements/progress/e-progress-circular'
import responsive from '~/mixins/pages/responsive'
import participants from '~/modules/documents/mixins/participants'
import { DOCUMENT_STATES } from '~/modules/documents/constants/documents'
import { PARTICIPANTS_ROLES } from '~/modules/documents/constants/participants'
import contentDialogContentTop from '~/mixins/dialogs/contentDialogContentTop'
import BlockDocumentShareLinkSocials from '~/modules/documents/components/blocks/pro-version/block-document-share-link-socials'
import shareDocumentActions from '~/modules/documents/mixins/shareDocumentActions'

export default {
  name: 'MDocumentShare',
  components: {
    BlockDocumentShareLinkSocials,
    EProgressCircular
  },
  mixins: [contentDialogContentTop, participants, responsive, shareDocumentActions],
  props: {
    document: {
      type: Object,
      default: null
    },
    closeModal: {
      type: Function,
      default: () => {}
    },
    closeDrawer: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      email: null,
      action: 'sign',
      publicAction: 'sign',
      documentPrivacy: null,
      newUsers: [],
      participantsLoading: false,
      loading: false,
      inputLoading: false,
      deleteLinkLoading: false,
      participantsDeleteLoading: {},
      showWrongEdrpouTooltip: false,
      wrongEdrpouTooltipMessage: '',
      requiredOwnerSignature: true
    }
  },
  computed: {
    ...mapGetters('participants', {
      participants: 'items',
      owner: 'owner'
    }),
    documentAccesses() {
      return [
        {
          text: 'Усі, хто мають посилання',
          value: 'public'
        },
        {
          text: 'Обмежений доступ',
          value: 'private'
        }
      ]
    },
    isPublicAccess() {
      return this.documentPrivacy === 'public'
    },
    isPrivateAccess() {
      return this.documentPrivacy === 'private'
    },
    emailInputRules() {
      if (isFinite(this.email)) {
        return 'min:8|max:10'
      }
      return 'email'
    },
    hasAddedUsers() {
      return this._.get(this.newUsers, 'length')
    },
    isOwnerSignatureRequired() {
      return this._.get(this.owner, 'isSignatureRequired', false)
    },
    disableSubmit() {
      return !this.hasAddedUsers && this.isOwnerSignatureRequired === this.requiredOwnerSignature
    },
    formattedParticipantActions() {
      if (this.document.canFillFields) {
        return this.participantActions
      }
      return this._.filter(this.participantActions, action => action.value !== 'fill')
    },
    actionByRoleMap() {
      return {
        [PARTICIPANTS_ROLES.VIEWER]: this._.find(
          this.participantActions,
          action => action.value === 'view'
        ),
        [PARTICIPANTS_ROLES.SIGNER]: this._.find(
          this.participantActions,
          action => action.value === 'sign'
        ),
        [PARTICIPANTS_ROLES.FILLER]: this._.find(
          this.participantActions,
          action => action.value === 'fill'
        )
      }
    },
    isDocumentSent() {
      return (
        [DOCUMENT_STATES.SENT, DOCUMENT_STATES.SIGNED].includes(this.document.state) ||
        !!this.participants.length
      )
    }
  },
  watch: {
    email() {
      if (this.showWrongEdrpouTooltip || this.$refs.email.errors?.email.length) {
        this.showWrongEdrpouTooltip = false
        this.$refs.email.reset()
      }
    },
    documentPrivacy(val, prev) {
      if (this.isPrivateAccess && prev) {
        this.deleteLink()
      }
      if (this.isPublicAccess) {
        window.dataLayer &&
          window.dataLayer.push({
            event: 'click_publicshare_link',
            email: this._.get(this.$User, 'email')
          })
      }
    }
  },
  async created() {
    await this.getParticipants()
    this.documentPrivacy = this._.get(this.document, 'hasPublicAccess') ? 'public' : 'private'
    for (const participant of this.participants) {
      this.$set(this.participantsDeleteLoading, participant.id, false)
    }
  },
  mounted() {
    window.dataLayer &&
      window.dataLayer.push({
        event: 'publicpage_view',
        email: this._.get(this.$User, 'email')
      })
  },
  methods: {
    async addUser() {
      const valid = await this.$refs.email.validate()
      if (!valid) {
        return
      }
      try {
        this.inputLoading = true
        const payload = { email: this.email, action: this.action }
        const isEdrpou = isFinite(this.email) && this.email.length >= 8 && this.email.length <= 10
        const isDuplicate =
          this.newUsers.find(user => this._.get(user, 'email') === this.email) ||
          this.participants.find(user => this._.get(user, 'user.email') === this.email)
        const isOwner = this.email === this.$User.email
        const isDuplicateEdrpou =
          this.newUsers.find(user => this._.get(user, 'edrpou') === this.email) ||
          this.participants.find(user => this._.get(user, 'organization.edrpou') === this.email)
        if (isDuplicate || isOwner) {
          this.$refs.email.setErrors({
            email: [this.$t('This email is already taken')]
          })
          return
        }
        if (isDuplicateEdrpou) {
          this.$refs.email.setErrors({
            email: [this.$t('This edrpou is already taken')]
          })
          return
        }
        if (isEdrpou) {
          payload.edrpou = this.email
          delete payload.email
        }
        const newUser = await this.$store.dispatch('participants/createDocumentParticipant', {
          documentId: this.document.id,
          payload,
          validate: true
        })
        const newUserPayload = {
          ...payload,
          id: newUser.id,
          name: this._.get(newUser, 'organization.name', null)
        }
        this.newUsers.push(newUserPayload)
        this.email = null
      } catch (e) {
        const errorCode =
          this._.get(e, 'response.data.status') || this._.get(e, 'response.data.code')
        if (errorCode === 400) {
          this.$refs.email.setErrors({
            email: ['']
          })
          this.wrongEdrpouTooltipMessage =
            this._.get(e, 'response.data.message') ||
            this.$t(
              'This organization is not yet registered in Dubidoc, we recommend sending the document to E-mail'
            )
          this.showWrongEdrpouTooltip = true
        } else {
          this.$handlers.error(e, this)
        }
      } finally {
        this.inputLoading = false
      }

      window.dataLayer &&
        window.dataLayer.push({
          event: 'add_email',
          email: this._.get(this.$User, 'email')
        })
    },
    async getParticipants() {
      try {
        this.participantsLoading = true
        await this.$store.dispatch('participants/getAllDocumentParticipantsWithOwner', {
          documentId: this.document.id
        })
        this.requiredOwnerSignature = this._.get(this.owner, 'isSignatureRequired', false)
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.participantsLoading = false
      }
    },
    deleteUser(userId) {
      this.newUsers = this._.filter(this.newUsers, user => user.id !== userId)
    },
    async deleteParticipant(participant) {
      try {
        this.participantsDeleteLoading[participant.id] = true
        await this.$store.dispatch('participants/delete', { id: participant.id })
        this.$notification.success(this.$t('Participant has successfully deleted'))
      } catch (e) {
        this.$handlers.error(e, this)
      } finally {
        this.participantsDeleteLoading[participant.id] = false
      }
    },
    async deleteLink() {
      try {
        await this.$store.dispatch('documents/deleteDocumentLink', this.document.id)
        this.updateDocumentLocally({ hasPublicAccess: false })
        this.documentLink = null
      } catch (e) {
        this.$handlers.error(e, this)
      }
    },
    updateDocumentLocally(data) {
      this.$store.commit('documents/UPDATE_DOCUMENT', { id: this.document.id, data })
    },
    async submit() {
      this.loading = true
      let occurredError = false
      if (this.isOwnerSignatureRequired !== this.requiredOwnerSignature) {
        await this.$store.dispatch('participants/update', {
          id: this.owner.id,
          payload: {
            isSignatureRequired: this.requiredOwnerSignature
          }
        })
      }
      for (const user of this.newUsers) {
        delete user.id
        if (!user.name) {
          delete user.name
        }
        try {
          await this.$store.dispatch('participants/createDocumentParticipant', {
            documentId: this.document.id,
            payload: user,
            saveItems: false
          })
        } catch (e) {
          occurredError = true
          this.$handlers.error(e, this)
        }
      }
      if (this.hasAddedUsers && !occurredError) {
        this.updateDocumentLocally({ state: DOCUMENT_STATES.SENT })
        window.dataLayer &&
          window.dataLayer.push({
            event: 'document_sent',
            email: this._.get(this.$User, 'email')
          })
        this.$notification.success(this.$t('Invitations have been sent'))
      }
      if (this.xsDevice) {
        this.closeDrawer(this.hasAddedUsers)
      } else {
        this.closeModal(this.hasAddedUsers)
      }
      this.loading = false
    },
    getParticipantName(p) {
      return p.edrpou ? this._.get(p, 'organization.name') : this._.get(p, 'user.email')
    }
  }
}
</script>

<style scoped lang="scss">
.form-document-share {
  &__header {
    background: $background-gray;
    padding: 40px 40px 0 40px;
  }
  &__content {
    padding: 32px 40px;
  }
  &__participants {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-bottom: 16px;
  }
  &__add {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 16px;

    @media (min-width: map-get($breakpoints, 'sm')) {
      flex-direction: row;
    }

    &-content {
      display: flex;
      align-items: center;
      flex-grow: 1;
      width: 100%;
      position: relative;

      @media (min-width: map-get($breakpoints, 'sm')) {
        width: auto;
      }
    }
    &-input {
      &::v-deep {
        .v-input__slot {
          padding-right: 0 !important;
        }
      }
    }
    &-action {
      width: 100%;

      position: relative;

      @media (min-width: map-get($breakpoints, 'sm')) {
        max-width: 170px;
      }
    }
  }
  &__add-mobile {
    width: 100%;
    border-radius: 16px;
    background: #fff;
    padding: 16px;

    &-menu {
      max-width: 95%;
      width: 100%;
      box-shadow: 0 0 50px 0 rgba(0, 0, 0, 0.12);
    }

    &-btn {
      width: 100%;
      position: relative;

      &-icon {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
      }

      &--top {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        border-bottom: 0.5px solid $background-secondary;
      }
      &--bottom {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
    }
  }
  &__icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;

    margin-right: 16px;

    display: flex;
    align-items: center;
    justify-content: center;

    background: #030102e0;

    &--green {
      background: #27ae60;
    }
    &--black {
      background: #030102e0;
    }
    &--gray {
      background: #f7f7f7;
    }
  }
  &__email {
    &--margin {
      margin-top: -5px;
    }
  }
  &__select {
    max-width: 215px;
    &::v-deep {
      .v-icon {
        margin-top: 0 !important;
        margin-left: -30px;
      }
    }

    &--private {
      &::v-deep {
        .v-icon {
          margin-top: 0 !important;
          margin-left: -60px;
        }
      }
    }
  }
  &__actions {
    padding: 40px;
    border-top: 1px solid $border-disabled;

    display: flex;
    justify-content: flex-end;

    @media (max-width: map-get($breakpoints, 'sm')) {
      padding-top: 30px;
      background: #ffffff;
      height: 80px;

      z-index: map-get($zIndexes, 'fixed');
    }

    &.public {
      justify-content: space-between;
      align-items: flex-end;
    }

    .v-btn {
      width: 148px;
      min-width: 148px;
    }
  }
  &__action {
    &-icon {
      &--disabled {
        opacity: 0.26;
      }
    }
  }
  &__delete {
    position: absolute;
    top: 50%;
    left: -45px;
    z-index: map-get($zIndexes, 'base');

    transform: translateY(-50%);
  }
  &__tooltip {
    position: relative;

    &:before {
      content: '';
      width: 12px;
      height: 12px;
      background: $dark;
      transform: rotateZ(45deg);
      position: absolute;
      top: -6px;
      left: 0;
      z-index: map-get($zIndexes, 'base');
    }

    &-content {
      pointer-events: auto;
      background: $dark;
    }

    &-close {
      width: 25px;
      height: 25px;
      position: absolute;
      top: 0;
      right: -5px;
      z-index: map-get($zIndexes, 'overAll');
    }
    &-title {
      color: $white;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;

      margin-bottom: 8px;
    }
    &-text {
      color: rgba(255, 255, 255, 0.64);
      font-size: 12px;
      font-weight: 300;
      line-height: 18px;
    }
  }

  &__plus-btn {
    position: relative;
    overflow: visible;
    z-index: map-get($zIndexes, 'base');

    svg {
      position: relative;
      z-index: map-get($zIndexes, 'middle');
    }

    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 32px;
      height: 32px;
      transform: translate(-50%, -50%) scale(0.3);
      border-radius: 50%;
      background: rgba($primary, 0.25);
      opacity: 0.7;
      pointer-events: none;
      animation: form-share-pulse 1.6s ease-out infinite;
    }
    &::after {
      animation-delay: 0.8s;
    }
  }

  @keyframes form-share-pulse {
    0% {
      transform: translate(-50%, -50%) scale(0.3);
      opacity: 0.7;
    }
    70% {
      transform: translate(-50%, -50%) scale(2);
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
